import React from "react";
import "./styles.scss";
import { ApplicationStatus } from "../../../../../../shared/constants/Constant";

interface IProps {
  status: ApplicationStatus;
}

const StatusLabel = (props: IProps) => {
  switch (props.status) {
    case ApplicationStatus.PENDING:
      return <div className="status-label pending">Pending</div>;
    case ApplicationStatus.ACCEPTED:
      return <div className="status-label accepted">Accepted</div>;
    default:
      return <div className="status-label rejected">Rejected</div>;
  }
};

export default StatusLabel;
